export function iswindowSizeMobile() {
    return window.innerWidth < 960;
}
